import React, { useEffect } from 'react'
import { Card, Flex } from 'antd'
import { useStore } from 'effector-react'
import { $walletsSummary, getWalletsSummary, walletsSummaryMounted } from './model'
import { getFinsystemNumberFormat } from '../../../../../libs/utils'
import styles from './styles.module.css'

const summaryItems = [
  { label: 'Сумма всех кошельков', key: 'totalBalanceUsd' as const },
  { label: 'Сумма In process', key: 'totalInProcess' as const },
  { label: 'LP', key: 'totalLP' as const },
  { label: 'Passive', key: 'totalPassive' as const },
  { label: 'Итого', key: 'grandTotal' as const },
]

export const WalletsSummary: React.FC = () => {
  const summary = useStore($walletsSummary)
  const loading = useStore(getWalletsSummary.pending)

  useEffect(() => {
    walletsSummaryMounted()
  }, [])

  return (
    <Card loading={loading} className={styles.card}>
      <Flex className={styles.row}>
        {summaryItems.map((item) => (
          <Flex vertical key={item.key} className={styles.item}>
            <span className={styles.label}>{item.label}</span>
            <span className={styles.amount}>
              {getFinsystemNumberFormat(summary[item.key], 2)}
              <span className={styles.unit}>USD</span>
            </span>
          </Flex>
        ))}
      </Flex>
    </Card>
  )
}
